import { useContext } from 'react';
import { ModalContext } from '../';
import type { ModalContextT } from './types';

export const useModals = (): ModalContextT => {
  const data = useContext(ModalContext);

  if (!data) {
    throw new Error('useModals was used outside of its Provider');
  }

  return data;
};
